import { IPassOfferBookingNowActionParams, passOfferBookNowAction } from "../../../Actions/LogicActions/Booking/PassOfferBookNowAction";
import { prepareBookingSummaryAction } from "../../../Actions/LogicActions/Checkout/Summary/PrepareBookingSummaryAction";
import { IPassBooking } from "../../../Orchestrator/Types/Types/BookingTypes";
import { getCmsAboutMonthlyPassAction } from "../../../Actions/LogicActions/CMSOffers/GetCmsAboutMonthlyPassAction";
import { getCmsAboutTravelPassAction } from "../../../Actions/LogicActions/CMSOffers/GetCmsAboutTravelPassAction";
import { getBestPriceForDateRangeAction } from "../../../Actions/LogicActions/Search/GetBestPriceForDateRangeAction";
import { uiPreferencesAction } from "../../../Actions/LogicActions/Search/GetUIPreferencesAction";
import { destinationBookNowAction } from "../../../Actions/UIActions/CMSDestination/DestinationBookNowAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { enumOfferPassType, TrainTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { IOfferPassType } from "../../../Orchestrator/Types/Types/OffersResponse";
import { ICMSBookNowParams } from "../../../Orchestrator/Types/Interface/ICmsDestination";
import { ICmsMonthlyPassOffer, ICmsTravelPassOffer } from "../../../Orchestrator/Types/Interface/ICMSOffers";
import { OffersContext } from "../Context/OffersContext";
import { getBookingDetailDataAction } from "../../../Actions/LogicActions/BookingDetail/GetBookingDetailDataAction";

class BookedPassDetailStep extends StepFlow {
  get stepName() {
    return "BookedPassDetail_step";
  }

  async onEventSetup(): Promise<void> {
    this.registerEventSubscription(
      _eventBus.on({
        eventName: evtTree.CMSOffers.OfferPass.Back,
        handler: async () => {
          updateRecoilState<IOfferPassType | null>("offerPassTypeAtom", null);
          updateRecoilState<ICmsMonthlyPassOffer | ICmsTravelPassOffer | null>("selectedCmsPassOfferAtom", null);

          updateRecoilState("selectedPassOfferAtom", null);
          updateRecoilState("passOfferResponseAtom", null);
          updateRecoilState("selectedPassBookingAtom", null);

          const context = this.getCtx<OffersContext>("offersContext");
          if (context) {
            context.routeTo = ["OffersInit_Step"];
            this.next();
          }
        },
      })
    )

    this.registerEventSubscription(
      _eventBus.on<{ passBooking: IPassBooking }, void>({
        eventName: evtTree.CMSOffers.BookedPassDetail.Init,
        handler: async ({ data }) => {
          const { passBooking } = data!;
          if (passBooking.booking && passBooking.booking.booking) {
            prepareBookingSummaryAction.setParams(passBooking.booking.booking);
            await prepareBookingSummaryAction.execute();

            getBookingDetailDataAction.setParams({
              bookingId: passBooking?.booking.booking.id
            })
            await getBookingDetailDataAction.execute()
          }
        }
      })
    );

    this.registerEventSubscription(
      _eventBus.on({
        eventName: evtTree.CMSOffers.BookedPassDetail.Back,
        handler: async () => {
          const context = this.getCtx<OffersContext>("offersContext");
          if (context) {
            updateRecoilState("selectedPassBookingAtom", null);
            context.routeTo = ["OffersInit_Step"];
            this.next();
          }
        },
      })
    )

    this.registerEventSubscription(
      _eventBus.on<{
        type: enumOfferPassType
      }, void>({
        eventName: evtTree.CMSOffers.BookedPassDetail.AboutPass,
        handler: async ({ data }) => {
          if (data) {
            if (data.type === enumOfferPassType.monthlyPass) {
              getCmsAboutMonthlyPassAction.execute();
            } else if (data.type === enumOfferPassType.travelPass) {
              getCmsAboutTravelPassAction.execute();
            }
          }
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on({
        eventName: evtTree.CMSOffers.BookedPassDetail.Help,
        handler: async () => {
          _eventBus.emit({
            eventName: "ROUTE_CHANGE",
            data: "/help",
          });
        }
      })
    )

    this.registerEventSubscription(
      _eventBus.on<{ startStop: string, endStop: string }, void>({
        eventName: evtTree.SelectDateModal.Open,
        handler: async ({ data }) => {
          if (data) {
            const { startStop, endStop } = data;

            await uiPreferencesAction.execute();
            let calendarDayInterval = uiPreferencesAction.result?.calendarDayInterval || 90

            getBestPriceForDateRangeAction.setParams({
              from: startStop,
              to: endStop,
              type: TrainTypeEnum.outbound,
              calendarDayInterval
            })
            await getBestPriceForDateRangeAction.execute();
          }
        },
      })
    );
    this.registerEventSubscription(
      _eventBus.on<IPassOfferBookingNowActionParams, void>({
        eventName: evtTree.DestinationDetail.BookNow.Click,
        handler: async ({ data }) => {
          if (data) {
            // Set flag to identify flow source
            localStorage.setItem("isFromPassDetailBookNow", "true");

            passOfferBookNowAction.setParams(data!);
            passOfferBookNowAction.execute();
          }
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<void, void>({
        eventName: evtTree.CMSOffers.FlowClose,
        handler: async () => {
          updateRecoilState("selectedPassBookingAtom", null);

          _eventBus.emit({
            eventName: "FLOW_CLOSE",
            data: "OffersFlow",
          });
        }
      })
    )
  }

  async onExecute(): Promise<void> {
    console.log("Booked Pass Detail Step Execute...");
  }
}

export const BookedPassDetailStepDeclaration = new StepDefinition({
  stepName: "BookedPassDetail_step",
  stepClass: BookedPassDetailStep,
});
